const DURATION_MS = 15000;
const MAX_PROGRESS = 90;
const TRANSITION_MS = 300;

export default class FilterProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.lineRef = React.createRef();
  }

  componentDidMount() {
    this.startTime = Date.now();
    this.animate();
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.frame);
  }

  setProgress = (progress) => {
    if (!this.lineRef.current) return;
    this.lineRef.current.style.width = `${progress}%`;
  };

  animate = () => {
    const elapsed = Date.now() - this.startTime;

    const progress = Math.min((elapsed / DURATION_MS) * MAX_PROGRESS, MAX_PROGRESS);

    this.setProgress(progress);

    if (progress < MAX_PROGRESS) {
      this.frame = requestAnimationFrame(this.animate);
    }
  };

  finishLoading = (callback = () => {}) => {
    cancelAnimationFrame(this.frame);

    this.setProgress(100);

    setTimeout(callback, TRANSITION_MS);
  };

  render() {
    const progressBar = (
      <div className='progress-bar'>
        <div
          ref={this.lineRef}
          className='progress-bar__fill'
          style={{
            width: '0%',
            transition: `width ${TRANSITION_MS}ms ease`,
          }}
        />
      </div>
    );

    const title = <div className={'progress-bar__title'}>Ищем лучшие варианты…</div>;

    return (
      <div className={'progress-bar-container'}>
        {window.isMobileDevice ? [progressBar, title] : [title, progressBar]}
      </div>
    );
  }
}
